import { render, staticRenderFns } from "./messageSetting.vue?vue&type=template&id=6967db34&scoped=true"
import script from "./messageSetting.vue?vue&type=script&lang=js"
export * from "./messageSetting.vue?vue&type=script&lang=js"
import style0 from "./messageSetting.vue?vue&type=style&index=0&id=6967db34&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6967db34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6967db34')) {
      api.createRecord('6967db34', component.options)
    } else {
      api.reload('6967db34', component.options)
    }
    module.hot.accept("./messageSetting.vue?vue&type=template&id=6967db34&scoped=true", function () {
      api.rerender('6967db34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/components/FormProDialog/messageSetting.vue"
export default component.exports